import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PartnerDto, PaymentResponseDto, SchoolBillDto } from '../../api/models';

import { QRCodeComponent } from 'angularx-qrcode';
import { ReceiptControllerService, SchoolBillControllerService } from '../../api/services';
import * as bootstrap from 'bootstrap';
import { AngularDeviceInformationService } from 'angular-device-information';
import { Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SessionService } from '../../common/session.service';
import { constants, PaymentNetwork } from '../../common/constants';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-cashier-school-payment',
  imports: [
    ReactiveFormsModule,
    QRCodeComponent, CommonModule,
    RouterLink
  ],
  templateUrl: './school-payment.component.html',
  styleUrl: './school-payment.component.css'
})
export class SchoolPaymentComponent implements OnInit {

  message = '';
  paymentNetwork?:PaymentNetwork;;
  fees = 0;
  isWallet = false;
  isBill = true;
  isPayment = false;

  qrCode = '';
  formPay: FormGroup;
  formBill: FormGroup;
  paymentNetworkOtpion = '';
  connectedSchool?: PartnerDto;
  idSchool?: number;
  taxe = 0;
  idStudent = '';

  bills: Array<SchoolBillDto> = [];
  selectedBill = false;
  bill: SchoolBillDto = {};
  showAnticipationLnk = false;
  idempotencyKey = '';
  processing = false;
  paymentMeans: PaymentNetwork[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private billService: SchoolBillControllerService,
    private receiptService: ReceiptControllerService,
    private sessionService: SessionService,
    private route: Router,
    private deviceInfo: AngularDeviceInformationService
  ) {

    this.formPay = this.formBuilder.group({
      phone: ['']
    });
    this.formBill = this.formBuilder.group({
      idStudent: ['', Validators.required]
    });

    this.paymentMeans= constants.getPaymentNetworks(environment.codeCountry, 'cashier');
  }

  ngOnInit(): void {
    const sess = this.sessionService.getSessionInfo();
      this.connectedSchool = sess.partner;
      this.idSchool = sess.partner?.id;
    
  }

  processPayment() {
    this.processing = true;
    if (this.idempotencyKey == '') {
      this.idempotencyKey = crypto.randomUUID();

      this.billService.pay({
        idBill: this.bill.id!!,
        paymentNetwork: this.paymentNetwork?.code!,
        paymentMean: this.formPay.value.phone,
        payNetworkOption: this.paymentNetworkOtpion
      }).subscribe(
        {
          next: (resp) => {
            this.processing = false;
            this.idempotencyKey = '';
            if (resp.status == 'PENDING') {
              if (this.paymentNetwork?.code.toUpperCase() == 'OMSN') {
                this.handleOrangemoneyResponse(resp);
              } else {
                if (resp.paymentUrl) {
                  this.openUrl(resp.paymentUrl);
                }
              }
            }else {
      this.route.navigateByUrl('/cashier/receipt/' + resp.reference);
    }
          },
          error: (err) => {
            this.processing = false;
            this.idempotencyKey = '';
            this.message = err.error.message;
            const elt = document.getElementById('modErrPay');
            const modAdd = new bootstrap.Modal(elt!!);
            modAdd.show();
          }
        }
      );
    } else {
      this.message = 'Le paiement est en cours de traitement. Veuillez patienter.';
      const elt = document.getElementById('modErrPay');
      const modAdd = new bootstrap.Modal(elt!!);
      modAdd.show();
    }
  }

  isValid() {
    let valid = false;
    if (this.paymentNetwork && !this.paymentNetwork.isMobileMoney) {
      valid = true;
    } else {
      let phone = this.formPay.value.phone;
      if (this.paymentNetwork?.code.toUpperCase() == 'OMSN') {
        if (this.deviceInfo.isDesktop()) {
          this.paymentNetworkOtpion = 'qrcode';
        } else {
          this.paymentNetworkOtpion = 'maxit';
        }
      }
      valid = phone != null && phone.length >= 9;
    }
    return valid;
  }

  completeForm(network: PaymentNetwork) {

    this.formPay.reset();
    this.paymentNetwork = network;
    const methods = document.querySelectorAll('.payment-method');

    this.isWallet = network.isMobileMoney;;

    methods.forEach(element => {
      if (element.getAttribute('data-method') == network.code) {
        element.classList.add('active');
      } else {
        element.classList.remove('active');
      }
    });
  }

  onSelectPaymentMethod(network: PaymentNetwork) {

    this.billService.getFeesAndTaxes1({
      idBill: this.bill.id!!,
      paymentMode: network.code
    }).subscribe(
      {
        next: (resp) => {
          this.taxe = resp.taxes;
          this.fees = resp.fees - this.taxe;
          this.completeForm(network);
        },
        error: (err) => {
          this.message = err.error.message;
          const elt = document.getElementById('modErrPay');
          const modAdd = new bootstrap.Modal(elt!!);
          modAdd.show();
        }
      }
    );
  }

  findBill() {
    if (!this.idSchool) {
      this.message = "Aucun établissement associé à votre compte";
      const elt = document.getElementById('modErrPay');
      const modAdd = new bootstrap.Modal(elt!!);
      modAdd.show();
      return;
    }
    let form = this.formBill.value;

    this.billService.findBillByStudent(
      form.idStudent,
      this.idSchool
    ).subscribe(
      {
        next: (resp) => {
          this.bills = resp;
          this.isBill = false;
          this.isPayment = true;
          if (this.bills.length == 1) {
            this.bill = this.bills.at(0)!!;
            this.selectedBill = true;
          }
        },
        error: (err) => {
          this.message = err.error.message;
          this.showAnticipationLnk = err.error.code == '1000';
          this.idStudent = form.idStudent;
          const elt = document.getElementById('modErrPay');
          const modAdd = new bootstrap.Modal(elt!!);
          modAdd.show();
        }
      }
    );
  }

  handleOrangemoneyResponse(resp: PaymentResponseDto) {
    if (resp.status == 'PENDING') {
      if (this.paymentNetworkOtpion == 'maxit') {
        if (resp.paymentUrl) {
          this.openUrl(resp.paymentUrl);
        }
      } else {
        this.qrCode = resp.qrCode!!;
        this.isPayment = false;
        this.finalizePayment(resp.reference!!);
      }
    }else {
      this.route.navigateByUrl('/cashier/receipt/' + resp.reference);
    }
  }

  async finalizePayment(reference: string) {
    this.receiptService.getPaymentDetails(
      reference
    ).subscribe({
      next: (resp) => {
        if (resp.status == 'PENDING') {
          setTimeout(() => {
            this.finalizePayment(reference);
          }, 20000);
        } else {
          this.route.navigateByUrl('/cashier/receipt/' + reference);
        }
      },
    });
  }

  openUrl(url: string) {
    window.open(url, '_self');
  }

  onSelectBill(bill: SchoolBillDto) {
    this.bill = bill;
    this.selectedBill = true;
  }
}
